/** Dirección pública de la oficina. El mapa es el enlace que compartimos. */
export const OFFICE_ADDRESS = 'Carretera Santa María 22, Edificio Intech';
export const OFFICE_MAPS_URL = 'https://maps.app.goo.gl/GkQUkiqvnUuS3ANc7';
